import React, { useRef, useState, useEffect } from 'react';
import i18next from 'i18next';
import { MdOutlineSearch } from 'react-icons/md';
import DistrictBox from './DistrictBox';
import { useTranslation } from 'react-i18next';

import { useMapsLibrary } from '@vis.gl/react-google-maps';

export default function CooperativeDistricts() {
    const placeInput = useRef<HTMLInputElement>(null);
    const [places, setPlaces] = useState<any[]>([]);
    const [cashedPlaces, setCashedPlaces] = useState<any[]>([]);
    // vis.gl libraries (may be null until loaded)
    const placesLib = useMapsLibrary('places');
    const geocodingLib = useMapsLibrary('geocoding');
    const [autocomplete, setAutocomplete] = useState<any | null>(null);
    const [geocoder, setGeocoder] = useState<any | null>(null);

    useEffect(() => {
        if (placesLib) {
            // placesLib provides AutocompleteService constructor
            try {
                setAutocomplete(new placesLib.AutocompleteService());
            } catch (e) {
                // fallback to window.google if available
                const googleAny: any = (window as any).google;
                if (googleAny?.maps?.places?.AutocompleteService) {
                    setAutocomplete(new googleAny.maps.places.AutocompleteService());
                }
            }
        }
    }, [placesLib]);

    useEffect(() => {
        if (geocodingLib) {
            try {
                setGeocoder(new geocodingLib.Geocoder());
            } catch (e) {
                const googleAny: any = (window as any).google;
                if (googleAny?.maps?.Geocoder) {
                    setGeocoder(new googleAny.maps.Geocoder());
                }
            }
        }
    }, [geocodingLib]);
    const { t } = useTranslation();

    return (
        <div className={'bg-SM-yellow py-10'}>
            <div className={'margin-home flex flex-col bg-white px-10 py-5'}>
                <h2 className={'margin-home mb-4 text-center font-medium'}>
                    {t(
                        'translation:MAIN_PAGE.COOPERATIVE_DISTRICTS.CHECK_IF_IN_YOUR_AREA_SM_WORKS',
                    )}
                </h2>
                <div className={'flex w-full p-2'}>
                    <input
                        ref={placeInput}
                        onChange={(event) => {
                            if (event.target.value === '') {
                                setPlaces([]);
                            }
                            autocomplete?.getPlacePredictions(
                                {
                                    input: event.target.value,
                                    componentRestrictions: { country: 'pl' },
                                    types: ['locality'],
                                },
                                    async (predictions: google.maps.places.AutocompletePrediction[] | null) => {
                                    console.log(cashedPlaces);
                                    if (!predictions) return;
                                    const _places: {
                                        geocoder: google.maps.GeocoderResponse;
                                        autocomplete: google.maps.places.AutocompletePrediction;
                                    }[] = [];

                                    for (const prediction of predictions) {
                                        const isInPlaces = cashedPlaces?.some(
                                            (place) =>
                                                place.results[0].place_id === prediction.place_id,
                                        );
                                        console.log(
                                            prediction.structured_formatting.main_text,
                                            isInPlaces,
                                        );
                                        if (!isInPlaces) {
                                            // use geocoder instance; convert callback-style geocode to Promise
                                            if (!geocoder) continue;
                                            const geoCoder = await new Promise<any>((resolve, reject) => {
                                                try {
                                                    geocoder.geocode({ placeId: prediction.place_id }, (results: any, status: any) => {
                                                        if (status === 'OK') resolve({ results, status });
                                                        else reject(status);
                                                    });
                                                } catch (err) {
                                                    reject(err);
                                                }
                                            }).catch(() => null);
                                            if (geoCoder) {
                                                setCashedPlaces((cashedPlaces) => [
                                                    ...cashedPlaces,
                                                    geoCoder,
                                                ]);
                                            }
                                        }
                                        const _cashedPlace = cashedPlaces.find(
                                            (place) => place?.results?.[0]?.place_id === prediction.place_id,
                                        );
                                        if (_cashedPlace) {
                                            _places.push({
                                                geocoder: _cashedPlace,
                                                autocomplete: prediction,
                                            });
                                        }
                                    }
                                    setPlaces(_places);
                                },
                            );
                        }}
                        className={`cooperative-districts-autocomplete mr-2 w-full border-b-2 px-2 py-1 outline-none focus:border-SM-yellow`}
                        placeholder={
                            i18next.t(
                                'translation:MAIN_PAGE.COOPERATIVE_DISTRICTS.LOCALIZATION',
                            ) as string
                        }
                    />
                    <button
                        className={
                            'w-fit rounded bg-SM-yellow p-2 ring-SM-yellow transition-all hover:text-white hover:ring-2'
                        }>
                        <MdOutlineSearch className={'text-xl'} />
                    </button>
                </div>
                {places.length > 0 && (
                    <div className={'mt-2 flex flex-col gap-3'}>
                        <hr />
                        {places?.map((place, index) => (
                            <DistrictBox key={`district-prediction-${index}`} place={place} />
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}
